<template>
    <div class="avatar-picker" :class="{ dragover: isDragOver }" @click="openFileDialog" @dragover.prevent="onDragOver"
        @dragleave.prevent="onDragLeave" @drop.prevent="onDrop">

        <input ref="fileInput" type="file" accept="image/*" class="hidden-input" @change="onFileSelect"
            name="file_select" id="file_select" />

        <img v-if="croppedImage" :src="croppedImage" @error="previewError = true" class="avatar-preview" alt="avatar"
            loading="lazy" />
        <Avatar v-else :user="user" class="avatar-preview" />

        <div class="placeholder">
            <img src="/photo.svg" alt="Photo" loading="lazy">
        </div>
    </div>
    <AvatarCropper v-if="avatarCropperVeiw && image" :image="image" @cropped="handleCropped"
        @close="avatarCropperVeiw = false"></AvatarCropper>
</template>

<script setup>
import { ref } from "vue";
import { useModalStore } from "@/stores/modalStore";
import AvatarCropper from "./AvatarCropper.vue";
import Avatar from "../Avatar.vue";

const { user } = defineProps({
    user: Object,
    avatar: String,
})

const previewError = ref(false);
const fileInput = ref(null);
const isDragOver = ref(false);
const modalStore = useModalStore();
const avatarCropperVeiw = ref(false);
const image = ref(null);
const croppedImage = ref(null)

const openFileDialog = () => fileInput.value.click();

const emit = defineEmits(['update:avatar'])

const handleCropped = ({ base64, blob, file }) => {
    croppedImage.value = base64
    emit("update:avatar", base64)
    avatarCropperVeiw.value = false
}

const handleFile = (file) => {
    const img = new Image()
    const reader = new FileReader()

    reader.onload = () => {
        img.src = reader.result
        img.onload = () => {
            const canvas = document.createElement('canvas')
            const max = 1024
            const scale = Math.min(max / img.width, max / img.height, 1)
            canvas.width = img.width * scale
            canvas.height = img.height * scale
            const ctx = canvas.getContext('2d')
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height)
            avatarCropperVeiw.value = true;
            image.value = canvas.toDataURL('image/jpeg', 0.9);
        }
    }
    reader.readAsDataURL(file)
};

const onFileSelect = (e) => {
    const file = e.target.files[0];
    if (file) {
        handleFile(file);
    }
    e.target.value = "";
};

const onDrop = (e) => {
    const file = e.dataTransfer.files[0];
    if (file) {
        handleFile(file);
    }
    fileInput.value.value = "";
};

const onDragOver = () => (isDragOver.value = true);
const onDragLeave = () => (isDragOver.value = false);
</script>

<style scoped>
.avatar-picker {
    min-width: 98px;
    min-height: 98px;
    width: 98px;
    height: 98px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    overflow: hidden;
    position: relative;
}

.avatar-picker.dragover {
    background: #e8f0ff;
}

.hidden-input {
    display: none;
}

.placeholder {
    position: absolute;
    background-color: rgba(255, 255, 255, 0.1);
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.2s ease;
}

.placeholder:hover {
    background-color: rgba(0, 0, 0, 0.2);
}

.avatar-preview {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
</style>
